export function isMobile() {
  return false;
}
